import React from 'react';
import Navbar from './navbar';
import Footer from './footer';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Navbar navLight={false} playBtn={false} bgLight={false} navCenter={true} />
      <div className="bg-black text-white min-h-screen pt-20">
        <div className="text-left px-6 py-8 max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold">Privacy Policy</h1>
            <p className="text-sm text-white">Last updated April 24, 2025</p>
          </div>
          <section className="mb-6 text-justify">

            <p className="mb-4">
              At Heart Felt, we are committed to protecting your personal information and your right to privacy.
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>

            <section id="info-we-collect" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">1. Information We Collect</h2>
              <ul className="list-disc list-inside space-y-1 ml-5">
                <li><strong>Personal Data:</strong> Name, email address, phone number, and other identifying information you provide when registering or using our services.</li>
                <li><strong>Usage Data:</strong> Pages visited, time spent on pages, clicks, IP address, browser type, and operating system.</li>
                <li><strong>Device Data:</strong> Information about the device used to access our services (e.g., mobile device ID, OS, and browser type).</li>
              </ul>
            </section>

            <section id="how-we-use-info" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">2. How We Use Your Information</h2>
              <p className="mb-2">We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-1 ml-5">
                <li>Provide, operate, and maintain our services</li>
                <li>Improve, personalize, and expand our services</li>
                <li>Understand and analyze usage trends</li>
                <li>Send you updates, promotional messages, or service-related emails</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section id="sharing-info" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">3. Sharing Your Information</h2>
              <p className="mb-2">
                We do not sell or rent your personal information. We may share your data with:
              </p>
              <ul className="list-disc list-inside space-y-1 ml-5">
                <li>Service providers who assist in operating our services</li>
                <li>Law enforcement or regulatory bodies as required by law</li>
                <li>Other parties with your consent or at your direction</li>
              </ul>
            </section>

            <section id="cookies" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">4. Cookies and Tracking</h2>
              <p className="mb-2">
                We use cookies and similar tracking technologies to track activity on our services and store certain information.
                You can modify your browser settings to refuse cookies, but this may affect your ability to use parts of our website.
              </p>
            </section>

            <section id="data-security" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">5. Data Security</h2>
              <p className="mb-2">
                We use administrative, technical, and physical security measures to help protect your personal information.
                However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section id="your-rights" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">6. Your Privacy Rights</h2>
              <ul className="list-disc list-inside space-y-1 ml-5">
                <li>Access and update your personal data</li>
                <li>Request deletion of your data</li>
                <li>Object to or restrict the processing of your data</li>
                <li>Withdraw consent for marketing communications</li>
              </ul>
              <p className="mt-2">
                To exercise these rights, contact us at <strong>support@heartfelt.com</strong>.
              </p>
            </section>

            <section id="third-party-links" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">7. Third-Party Links</h2>
              <p className="mb-2">
                Our services may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites.
              </p>
            </section>

            <section id="policy-updates" className="mb-6">
              <h2 className="text-xl font-semibold mb-2">8. Policy Updates</h2>
              <p className="mb-2">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with the effective date.
              </p>
            </section>

            <section id="contact-us">
              <h2 className="text-xl font-bold mb-2">12. Contact Us</h2>
              <p className="mb-2">
                If you have questions or comments about these Terms and Conditions, please contact us at:
              </p>
              <p className="mb-2">
                <strong>Address:</strong>Salana Jiwan Singh Wala, Amloh Punjab - 147301<br />
                <strong>Email:</strong> info@devinnovations.co.in<br />
              </p>
            </section>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
